import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { ApiError } from 'types/utils/api-response';
import { api } from 'constants/api';
import { ApiResponse } from 'types/utils/api-response';
import { MutationOptions } from 'types/utils/mutation-options';

export type RemoveAudienceResponseType = {};

export const useRemoveAudience = (
  options?: MutationOptions<
    RemoveAudienceResponseType,
    { audience_id: string },
    AxiosError<ApiError>
  >
) =>
  useMutation({
    mutationFn: async ({ audience_id }) => {
      const { data } = await api.delete<
        ApiResponse<RemoveAudienceResponseType>
      >(`/audience/${audience_id}`);

      return data.data;
    },
    ...options,
  });
